export const createPatientFromExternalIdRefusalCodes = [
    "no-organisation",
    "unsupported-system",
    "unknown-instance",
    "instance-not-enabled",
    "pds-not-enabled",
    "no-patient-identifier",
];
//# sourceMappingURL=patientRequests.js.map